export const GTM_GENERIC_EVENT = 'GTM_GENERIC_EVENT';

export const GTM_USER_EVENT = 'GTM_USER_EVENT';
export const GTM_USER_EVENT_CART = 'GTM_USER_EVENT_CART';
export const GTM_USER_EVENT_DEFAULT_DATE = 'GTM_USER_EVENT_DEFAULT_DATE';
export const GTM_USER_EVENT_TELL_US_MORE = 'GTM_USER_EVENT_TELL_US_MORE';
export const GTM_PAGE_VIEW = 'GTM_PAGE_VIEW';
export const GTM_USER_EVENT_ADD_PACKAGE = 'GTM_USER_EVENT_ADD_PACKAGE';
export const GTM_IS_IDK = 'GTM_IS_IDK';
export const GTM_USER_SIDEBAR_BUTTON = 'GTM_USER_SIDEBAR_BUTTON';
export const GTM_USER_EVENT_MILEAGE_ENTERED = 'GTM_USER_EVENT_MILEAGE_ENTERED';
export const GTM_USER_EVENT_SIGN_ENTERED = 'GTM_USER_EVENT_SIGN_ENTERED';
export const GTM_USER_EVENT_NOTES_ENTERED = 'GTM_USER_EVENT_NOTES_ENTERED';
export const GTM_USER_EVENT_SIGNATURE_FULL_SCREEN =
  'GTM_USER_EVENT_SIGNATURE_FULL_SCREEN';
export const GTM_USER_EVENT_OPEN_DISCLAIMER_MODAL =
  'GTM_USER_EVENT_OPEN_DISCLAIMER_MODAL';

// Setting Dimensions
export const GTM_SET_DIMENSION_CONFIRMATION_KEY =
  'GTM_SET_DIMENSION_CONFIRMATION_KEY';
export const GTM_SET_DIMENSION_RESERVATION_ID =
  'GTM_SET_DIMENSION_RESERVATION_ID';
export const GTM_SET_DIMENSION = 'GTM_SET_DIMENSION';



// WEBPACK FOOTER //
// ./src/store/reducers/gtm/actionTypes.js